.nest-card {
  @apply rounded border relative bg-white;

  h4 {
    @apply font-semibold;
  }

  p {
    @apply leading-tight;
  }

  &__content {
    @apply text-sm text-muted-foreground leading-none;
  }

  &__icon {
    position: absolute;
    top: 12px;
    right: 12px;

    @apply w-5 h-5;
  }

  &__redirect {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 12px;
    margin: auto;

    @apply w-5 h-5;
  }

  &--redirect {
    @apply cursor-pointer hover:border-blue-600/50;
  }
}


